import { RefObject } from "react";

export const SaveToSession = (
    phoneNumberInputRef: RefObject<HTMLInputElement | null>,
) => {
    const formData = {
        phoneNumber: phoneNumberInputRef.current?.value || "",
    };
    sessionStorage.setItem('logInForm', JSON.stringify(formData));
};
